import { render, staticRenderFns } from "./StockPurchaseConsolidated.vue?vue&type=template&id=2274a142&"
import script from "./StockPurchaseConsolidated.vue?vue&type=script&lang=js&"
export * from "./StockPurchaseConsolidated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports